import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPlus } from "@fortawesome/free-solid-svg-icons";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import DashboardHeader from "../components/Other/DashboardHeader";
import { useTranslation } from "react-i18next";
import { createPost, s3Upload, getpost, getGameFromSlug } from "../api/user";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ProcessingButton from "../components/Skeleton/ProcessingButton";
import { SkeletonBlock } from "../components/Skeleton/Skeleton";
import { event } from "../utils/event";
import { PreviewVideo } from "./previewVideo";
import { SUBSCRIPTION_ENABLED, isPostLocked, isQuillEmpty } from "../utils/utils";
import PostRichTextEditor from "../components/pages/PostRichTextEditor";

const CreatePostPage = (props) => {
  const { postId } = useParams();
  const { t } = useTranslation();
    const game_id = props.gameId ?? null;
  const slug = props.slug ?? null;
  const navigate = useNavigate();
  // Embedded mode: this editor is hosted in a modal (a league's post composer),
  // so the host owns the chrome and decides what happens after a successful post.
  // Without it the modal would contain a second header, container and league nav.
  const embedded = !!props.embedded;
  const onDone = props.onDone;
  // AuthLayout passes this context as an array; the Contest layout passes an
  // object. The modal renders under Contest, so read it without destructuring.
  const outletContext = useOutletContext();
  const sidebarToggle = Array.isArray(outletContext)
    ? outletContext[0]
    : outletContext?.sidebarToggle;
  const isMobileView = document.body.clientWidth <= 768;
  const [images, setImages] = useState([]);
  const [description, setDescription] = useState("");
  const [postStatus, setPostStatus] = useState("1");
  const [imgurl, setImgUrls] = useState([]);
  const [loading, setLoading] = useState(false);
  // `posting` is the Go Public / Update Post submit; `loading` stays with media
  // upload and the league prefetch. Sharing one flag meant a submit also blanked
  // the uploaded thumbnails.
  const [posting, setPosting] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [deletedImageIds, setDeletedImageIds] = useState([]);
  const user = JSON.parse(localStorage.getItem("userInfo"));
  const [game, setGame] = useState(null);

  const flutter = localStorage.getItem("isFlutterInAppWebViewReady");

  const videoExtensionsRegex = /\.(mp4|mov|avi|wmv)$/i;

  const [isPreviewVideo, setIsPreviewVideo] = useState(false);
  const [attachments, setAttachments] = useState("");

  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);

  const fetchPost = async (Id) => {
    try {
      const response = await getpost({ post_id: Id });
      if (response) {
        setisDataFeteched(true);
        const postData = response?.data?.data;
        if (isPostLocked(postData?.created_at)) {
          toast.error(t("post_locked_message"));
          navigate(-1);
          return;
        }
        console.log(postData?.post_status, "postData?.post_status ");
        setDescription(postData?.description || "");
        setPostStatus(postData?.post_status);
        const imges = postData?.post_image.map((val, index) => {
          return { id: val?.id, preview: val?.image };
        });
        setImages(imges || []);
        setIsDisabled(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsDisabled(false);
    }
  };


  useEffect(() => {
    const checkGameDates = (start_date, end_date) => {
      const endDate = new Date(end_date.replace(" ", "T")); // Parse game.end_date
      const startDate = new Date(start_date.replace(" ", "T")); // Parse game.start_date
      const today = new Date(); // Get today's date
      today.setHours(0, 0, 0, 0); // Set time to midnight to ignore time component

      if (today >= startDate && today <= endDate) {
        return true;
      } else {
        return false;
      }
    };

    // const fetchGameId = async (slug) => {
    //   try {
    //     const response = await getGameFromSlug({ slug });
    //     const gameData = response?.data?.data;

    //     if (gameData) {

    //       if(checkGameDates(gameData.start_date, gameData.end_date)){
    //         setGame(gameData);
    //         setLoading(true);
    //       }else{
    //         toast.error("Game is not active");
    //         navigate("/contest/my-games");
    //       }
    //     } else {
    //       toast.error("Game not found");
    //       navigate("/contest/my-games");
    //     }

    //   } catch (error) {
    //     console.error("Error fetching game ID:", error);
    //   }
    // };

    const fetchGameId = async (slug) => {
      try {
        const response = await getGameFromSlug({ slug });
        const gameData = response?.data?.data;

        if (gameData) {
          if (checkGameDates(gameData.start_date, gameData.end_date)) {
            const gameType = localStorage.getItem("game_type");
            const isAuthenticated = localStorage.getItem("isAuthenticated");

            if (gameData.game_type === "private") {
              if (gameType === "private" && !isAuthenticated) {
                // toast.error("You need to authenticate to access this game.");
                // navigate("/contest");
                              setGame(gameData);
              setLoading(false);
              } else if (gameType === "private" && isAuthenticated) {
                setGame(gameData);
                setLoading(false);
              } else {
                // toast.error("You cant access this league withouth password.");
                // navigate("/contest");
              setGame(gameData);
              setLoading(false);
              }
            } else {
              setGame(gameData);
              setLoading(false);
            }
          } else {
                setGame(gameData);
                setLoading(false);
            // toast.error("League is not active");
            // // navigate("/contest/my-games");
            // navigate("/contest/my-games", { state: { viewMode: "member" } });
          }
        } else {
          // toast.error("League not found");
          // navigate("/contest/my-games");
          // navigate("/contest/my-games", { state: { viewMode: "member" } });
        }
      } catch (error) {
        console.error("Error fetching game ID:", error);
      }
    };

    fetchGameId(slug);

    // return () => {
    //   localStorage.removeItem("game_type");
    //   localStorage.removeItem("isAuthenticated");
    // };
  }, [slug]);


  useEffect(() => {
    if (postId) {
      if (!isDataFeteched) fetchPost(postId);
    }
  }, [postId, isDataFeteched]);

  useEffect(() => {
    return () => {
      images.forEach((image) => URL.revokeObjectURL(image.preview));
    };
  }, [images]);

  const handleRemoveImage = (index) => {
    console.log(index, "index1");
    const updatedImages = [...images];
    console.log(updatedImages, "img");
    const deletedImageId = updatedImages[index]?.id;
    console.log(deletedImageId, "dimg");
    updatedImages.splice(index, 1);
    setImages(updatedImages);
    console.log(updatedImages, "uimg");
    const imgs = imgurl.filter((val, index1) => index1 !== index);
    setImgUrls(imgs);
    console.log(imgs, "indexfinaql");
    setDeletedImageIds((prevIds) => {
      const newIds = [...prevIds, deletedImageId];
      return newIds;
    });
  };

  const handleImageUpload = async (e) => {
    const selectedFiles = e.target.files;
    const allowedExtensionsRegex = /\.(jpg|jpeg|png|svg|mp4|mov|avi|wmv)$/i;

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];

      const maxSize = 512 * 1024 * 1024;
      if (!allowedExtensionsRegex.test(file?.name)) {
        toast.error("Choose an image or video.");
        return;
      }
      if (file?.size > maxSize) {
        toast.error("File must be 512 MB or smaller.");
        return;
      }
    }

    const newImages = Array.from(selectedFiles)
      .slice(0, 5 - images.length)
      .map((file) => ({
        id: null,
        image: null,
        blob: file,
        preview: URL.createObjectURL(file),
      }));
    setImages((prevImages) => [...prevImages, ...newImages]);

    try {
      setLoading(true);

      const response = await s3Upload(newImages);
      if (response) {
        const imageArray = response.data.data.map((path) => ({ image: path }));
        const imageJsonString = imageArray;
        setImgUrls((prevImages) => [...prevImages, ...imageJsonString]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const dropdownStyle = {
    fontSize: "12px",
    padding: "2px 10px 5px 17px",
    border: "2px solid #35b23c",
    borderRadius: "30px",
    color: "#35b23c",
  };

  const dropdownHandler = (event) => {
    setPostStatus(event.target.value);
  };

  useEffect(() => {
    const handleCustomProfileEvent = (event) => {
      if (event?.detail?.imagePost) {
        const rawData = event.detail.imagePost;
        const files = rawData.split(",");
        const unescapedData = files.map((val) =>
          val.replace(/^\[|\]$/g, "").trim()
        );
        const baseUrl = user?.s3_url;

        const imageUrls = unescapedData.map((image) => ({
          preview: baseUrl + image.replace(/\[|\]/g, "").replaceAll(`"`, ""),
        }));

        const imageUrls1 = unescapedData.map((image) => ({
          image: image.replace(/\[|\]/g, "").replaceAll(`"`, ""),
          preview: image.replace(/\[|\]/g, "").replaceAll(`"`, ""),
        }));

        setImages((prevImages) => [...prevImages, ...imageUrls]);
        setImgUrls((prevImages) => [...prevImages, ...imageUrls1]);
      }
    };

    window.addEventListener("myCustomPostEvent", handleCustomProfileEvent);
    return () => {
      window.removeEventListener("myCustomPostEvent", handleCustomProfileEvent);
    };
  }, [user, window.addEventListener]);

  const handleCreateOrUpdatePost = async () => {
    if (posting) return;
    setPosting(true);
    const cleanDescription = isQuillEmpty(description) ? null : description;
    const body = {
      description: cleanDescription,
      caption: null,
      tag: null,
      post_status: postStatus || null,
    };
    if (imgurl.length > 0) {
      body.image_json = JSON.stringify(imgurl);
    } else {
      body.imageJsonString = "";
    }
    if (!body.description && !body.image_json) {
      toast.error("Add text or an image to publish.");
      setPosting(false);
      return;
    }
    setIsDisabled(true);
    try {
      if (postId) {
        const body1 = {
          description: cleanDescription,
          caption: "",
          tag: "",
          post_status: postStatus,
          post_id: postId,
          delete_images: deletedImageIds,
        };

          if (game_id) {
            body1.game_id = game_id;
          }

        if (imgurl.length > 0) {
          body1.image_json = JSON.stringify(imgurl);
        }
        const response = await createPost(body1);
        if (response.status === 200) {
          setPosting(false);
          setIsDisabled(false);
          localStorage.removeItem("imagePost");
          toast.success("Post updated.");
          // Hosted in a modal: the host closes it and refreshes its own feed —
          // navigating away would drop the user out of the league.
          if (embedded) {
            onDone?.();
          } else if(game_id){
             // The league's Home is where a league post belongs — /:slug/feeds is
             // the pre-revamp page, kept only for the /oldcontest comparison. Any
             // path that still reaches this editor full-page lands on Home too.
             navigate(`/contest/${slug}`);
          }else{
          navigate("/feed");
          }
        } else if (response.status === 400) {
          setPosting(false);
          setIsDisabled(false);
          toast.error("Could not save changes to the post. Try again.");
        }
      } else {
            if (game_id) {
              body.game_id = game_id;
            }

        const response = await createPost(body);
        if (response.status === 200) {
          setPosting(false);
          setIsDisabled(false);
          localStorage.removeItem("imagePost");
          toast.success(
            response.data?.data?.moderation_status === "pending_review"
              ? "Post submitted for review."
              : "Post published."
          );
          // Hosted in a modal: the host closes it and refreshes its own feed —
          // navigating away would drop the user out of the league.
          if (embedded) {
            onDone?.();
          } else if(game_id){
              // The league's Home is where a league post belongs — /:slug/feeds is
              // the pre-revamp page, kept only for the /oldcontest comparison.
              navigate(`/contest/${slug}`);
          }else{
          navigate("/feed");
          }
        } else if (response.status === 400) {
          setPosting(false);
          setIsDisabled(false);
          toast.error("Could not publish the post. Try again.");
        }
      }
    } catch (error) {
      setPosting(false);
      console.error("Error:", error);
      setIsDisabled(false);
      toast.error(
        postId
          ? "Could not save changes to the post. Try again."
          : "Could not publish the post. Try again."
      );
    }
  };

  const handlePlayClick = (index) => {
    const video = document.querySelector(`#video-${index}`);
    const playButton = document.querySelector(`#play-button-${index}`);

    if (currentVideoIndex !== null && currentVideoIndex !== index) {
      // Pause the current video if another video is clicked
      const currentVideo = document.querySelector(
        `#video-${currentVideoIndex}`
      );
      currentVideo.pause();
    }

    if (video.paused) {
      video.play();
      setCurrentVideoIndex(index);
      playButton.style.display = "none";

      video.onended = () => {
        playButton.style.display = "block";
      };
    } else {
      video.pause();
      playButton.style.display = "block"; // Show play button if video is paused
      setCurrentVideoIndex(null); // Reset current video index
    }
  };

  const handleCloseVideoClick = () => {
    setIsPreviewVideo(false);
    setAttachments("");
  };

  const Shell = embedded ? "div" : PageContainer;
  const shellProps = embedded ? {} : { gamePage: game_id && true };

  return (
    <>
      {!embedded && <DashboardHeader toggle={sidebarToggle}  {...(game && { game })} />}
      {!embedded && !game_id &&
      /* Desktop: hide the title text + grey line on Create Post (no postId).
         Edit mode keeps its "Update Post" title bar unchanged. */
      <PageHeaderTitle title={postId ? t("Update Post") : t("create_post")} showDesktopTitle={!!postId} />
      }
      <Shell {...shellProps}>
          {/* Client Rev 2, composer 10: "Remove the organizer image that sits at
              the top of the page and the league title that shows up above this
              image."
              Both came from GameSideBar — it renders the league's uploaded cover
              (MobileCover) above the form on mobile, and the title above it was
              the PageHeaderTitle this screen no longer prints. GameSideBar is the
              OLD in-page league nav (Posts / Buy-Sell / Charts / Portfolio /
              Leaderboard); on a focused compose screen it is chrome the client
              asked to strip, and the back arrow plus the bottom bar already carry
              the navigation. Not rendered here at all — every other screen that
              mounts it is untouched. */}
          <div>
        <div className=" md:block  rounded-2xl bg-white max-w-[60rem] mx-auto">
          <div
            className={
              isMobileView
                ? "py-4 mb-5 px-2 max-w-[65rem] bg-white mx-auto"
                : // Client Rev 2, desktop composer modal: "Right now, the composer
                  // box, the upload media tab, and the Post to League CTA are not
                  // centered in the modal. These blocks are shifted right. Keep the
                  // modal's width as is, but center the internal blocks."
                  // `ml-3` was a bare LEFT margin with no right counterpart, so
                  // every block inside sat 12px right of centre. `mx-auto` on a
                  // capped width centres them instead. Only in the modal
                  // (`embedded`); the full-page /create-feed screen keeps the
                  // margin it has always had.
                  // `mx-auto` alone was not enough, and the follow-up report said so: with the
                  // wrapper narrower than the panel it centres, but this wrapper is NOT
                  // narrower — `max-w-[65rem]` never binds inside a `md:max-w-2xl` (672px)
                  // modal, so the wrapper is exactly the panel's width and `mx-auto` has
                  // nothing to distribute. Measured at 1440px: header, editor, upload box,
                  // CTA and footer all sat at an inset of 0px on BOTH sides — their centres
                  // agreed (720 each, which is why the first check passed) while every block
                  // ran flush into the panel's rounded edge. `px-6` is what actually holds
                  // them off it, equally. Modal only; /create-feed is untouched.
                  `mt-2 py-4 max-w-[65rem] bg-white ${embedded ? "mx-auto px-6" : "ml-3"}`
            }
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <img
                  src={user?.image || "/qushi_logo.png"}
                  alt={user?.user_name || "user"}
                  className="rounded-full object-cover bg-gray-100"
                  /* Client Rev 2, desktop composer modal: "[avatar] username -
                     Reduce the current size of the avatar its too big." 44 -> 36px,
                     which is the same avatar CreatedByBlock and the league rail
                     use. Modal only; the full-page composer keeps 44. */
                  style={
                    embedded
                      ? { width: "36px", height: "36px", marginRight: "10px" }
                      : { width: "44px", height: "44px", marginRight: "10px" }
                  }
                />
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-gray-800">
                    {user?.user_name || "QUSHi Official"}
                  </span>
                  {/* Client Rev 2, composer 3: "Under the username, show:
                      Posting to [League title]. 'Posting to' is permanent copy.
                      League title is dynamic."
                      Outside a league it stays the sitewide line it always was —
                      this screen is still the main Create Post. */}
                  <span className="text-[11px] text-gray-400">
                    {game_id && (props.game?.title || game?.title)
                      ? `Posting to ${props.game?.title || game?.title}`
                      : t("posting_to_public_feed")}
                  </span>
                </div>
              </div>
              {SUBSCRIPTION_ENABLED ? (
                <select
                  value={postStatus}
                  onChange={dropdownHandler}
                  style={dropdownStyle}
                >
                  <option value="1">{t("Public")}</option>
                  <option value="2">{t("private")}</option>
                </select>
              ) : null}
              {/* Client Rev 3, desktop private league: "Remove the redundant part
                  at the top of the composer modal that i circled in blue. then we
                  can move the x close out down inline with the username right
                  aligned. Composer will shrink in height."
                  The modal used to print its own "New Post / Posting to <league>"
                  bar above this row — which repeated, word for word, the "Posting
                  to <league>" line already under the username. That bar is gone
                  (see LeaguePostModal), and its close button moves here, on the
                  username row's right edge. Only rendered when the host passes a
                  closer, so the full-page /create-feed screen is unaffected. */}
              {props.onClose ? (
                <button
                  type="button"
                  onClick={props.onClose}
                  aria-label="Close"
                  className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-[#66748C] hover:bg-[#F3F4F6]"
                >
                  <svg
                    viewBox="0 0 24 24"
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    aria-hidden="true"
                  >
                    <path d="m6 6 12 12M18 6 6 18" strokeLinecap="round" />
                  </svg>
                </button>
              ) : null}
            </div>

            {/* Client Rev 2: "Reduce some vertical bulk. The width is good. The
                writing area and upload area together make the modal taller than
                necessary. I would shorten the initial text area somewhat. It can
                expand as the user types."
                `post-editor--compact` drops the editor's 9rem floor to 5.5rem; the
                editor still grows with the text, so nothing is lost — only the
                empty starting height. Modal only. */}
            <div className={`mt-2 ${embedded ? "post-editor--compact" : ""}`}>
              <PostRichTextEditor
                value={description}
                onChange={setDescription}
                // Client Rev 2, composer 4: "Change the composer placeholder
                // from 'Say something worth reading.' to 'Share something with
                // the league.'" League only — the main composer keeps its own.
                placeholder={
                  game_id
                    ? "Share something with the league."
                    : t("say_something_worth_reading")
                }
                isMobileView={isMobileView}
              />
            </div>
            {/* "The media upload box can also lose a little height. This will make
                the modal feel tighter and more premium without making it cramped."
                — the dashed box only, in the modal only. */}
            <div className="mt-3">
              {flutter ? (
                <div className={embedded ? "py-1" : "py-2"}>
                  <label
                    htmlFor="upload"
                    onClick={() => event("imageUploadPost")}
                    className="flex flex-col items-center justify-center text-center py-4 rounded-xl border-2 border-dashed border-gray-300 cursor-pointer"
                  >
                    <input
                      type="file"
                      id="upload"
                      accept="image/*,video/*"
                      multiple
                      onChange={handleImageUpload}
                      className="hidden"
                      disabled={true}
                    />
                    <FontAwesomeIcon
                      icon={faPlus}
                      className="text-gray-400 text-2xl"
                      style={{ fontWeight: "300" }}
                    />
                    <span className="text-xs text-gray-500 mt-1">
                      {t("upload_media_files")}
                    </span>
                  </label>
                </div>
              ) : (
                <div className={embedded ? "py-1" : "py-2"}>
                  <label
                    htmlFor="upload"
                    className={`flex flex-col items-center justify-center text-center rounded-xl border-2 border-dashed border-gray-300 cursor-pointer ${
                      embedded ? "py-3" : "py-4"
                    }`}
                  >
                    <input
                      type="file"
                      id="upload"
                      accept="image/*,video/*"
                      multiple
                      onChange={handleImageUpload}
                      className="hidden"
                    />
                    <FontAwesomeIcon
                      icon={faPlus}
                      className="text-gray-400 text-2xl"
                      style={{ fontWeight: "300" }}
                    />
                    <span className="text-xs text-gray-500 mt-1">
                      {t("upload_media_files")}
                    </span>
                  </label>
                </div>
              )}

              <div className="flex flex-wrap">
                {/* Uploading media: a thumbnail-shaped placeholder in the grid,
                    in place of the old screen-covering spinner. */}
                {loading && (
                  <div className="w-full md:w-1/3 p-4">
                    <SkeletonBlock
                      height={180}
                      rounded="rounded-lg"
                      className="w-full"
                    />
                  </div>
                )}
                {images.map((img, index) => {
                  return (
                    <div key={index} className="w-full md:w-1/3 p-4 relative">
                      {img?.blob?.name ? (
                        <>
                          {videoExtensionsRegex.test(img?.blob?.name.split('?')[0]) ? (
                            <>
                              <div class="relative">
                                <video
                                  autobuffer
                                  playsInline={true}
                                  webkit-playsinline="true"
                                  x5-playsinline="true"
                                  x-webkit-airplay="deny"
                                  disablePictureInPicture={true}
                                  controlsList="nodownload"
                                  onContextMenu={(e) => e.preventDefault()}
                                  preload="auto"
                                  id={`video-${index}`}
                                  controls
                                  className="w-full h-52 rounded-lg"
                                  onClick={(e) => {
                                    // Reset video playback to start from 0 seconds
                                    e.target.currentTime = 0;
                                    // Handle play click event
                                    handlePlayClick(index);
                                  }}
                                >
                                  <source src={img?.preview} />
                                </video>
                                {isMobileView ? (
                                  ""
                                ) : (
                                  <button
                                    id={`play-button-${index}`}
                                    className="absolute rounded-lg inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white"
                                    style={{ display: "block" }}
                                    onClick={() => handlePlayClick(index)}
                                  >
                                    <FontAwesomeIcon
                                      className="h-7"
                                      icon={faPlay}
                                    />
                                  </button>
                                )}
                              </div>
                              <button
                                onClick={() => handleRemoveImage(index)}
                                className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                              >
                                &times;
                              </button>
                            </>
                          ) : (
                            <>
                              <img
                                src={img?.preview}
                                alt={`Preview ${index}`}
                                style={{ maxWidth: "100%", maxHeight: "100%" }}
                              />
                              <button
                                onClick={() => handleRemoveImage(index)}
                                className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                              >
                                &times;
                              </button>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {videoExtensionsRegex.test(img?.preview.split('?')[0]) ? (
                            <>
                              <div class="relative">
                                <video
                                  autobuffer
                                  playsInline={true}
                                  webkit-playsinline="true"
                                  x5-playsinline="true"
                                  x-webkit-airplay="deny"
                                  disablePictureInPicture={true}
                                  controlsList="nodownload"
                                  onContextMenu={(e) => e.preventDefault()}
                                  preload="auto"
                                  id={`video-${index}`}
                                  controls
                                  className="w-full h-52 rounded-lg"
                                  onClick={(e) => {
                                    // Reset video playback to start from 0 seconds
                                    e.target.currentTime = 0;
                                    // Handle play click event
                                    handlePlayClick(index);
                                  }}
                                >
                                  <source src={img?.preview} />
                                </video>
                                {isMobileView ? (
                                  ""
                                ) : (
                                  <button
                                    id={`play-button-${index}`}
                                    className="absolute inset-0 rounded-lg flex items-center justify-center bg-black bg-opacity-50 text-white"
                                    style={{ display: "block" }}
                                    onClick={() => handlePlayClick(index)}
                                  >
                                    <FontAwesomeIcon
                                      className="h-7"
                                      icon={faPlay}
                                    />
                                  </button>
                                )}
                              </div>
                              <button
                                onClick={() => handleRemoveImage(index)}
                                className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                              >
                                &times;
                              </button>
                            </>
                          ) : (
                            <>
                              <img
                                src={img?.preview}
                                alt={`Preview ${index}`}
                                style={{ maxWidth: "100%", maxHeight: "100%" }}
                              />
                              <button
                                onClick={() => handleRemoveImage(index)}
                                className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                              >
                                &times;
                              </button>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            {/* Client Rev 2, composer 6: "Remove Share to other social media
                from the League composer." A private league's whole promise is
                that what happens in it stays in it, so an X / TikTok / Instagram
                cross-post is the one control that must not be on this screen.
                The main QUSHi composer keeps it. */}
            {!game_id && (
              <div className="flex items-center mt-4 mb-2">
                <input
                  type="checkbox"
                  id="socialMedia"
                  name="socialMedia"
                  className="rounded-md border-gray-300 text-gray-500 w-4"
                />
                <label
                  htmlFor="socialMedia"
                  className="ml-2 text-xs text-gray-500 font-normal inline-block"
                >
                  {t("share_to_other_social_media_(X_TikTok_Instagram)")}
                </label>
              </div>
            )}
            <div className="text-center pr-0 mb-0">
              {/* Inline processing: label swaps to a short gerund with the
                  indicator inside the button, same fill, no duplicate submit. */}
              <ProcessingButton
                unavailable={!!isDisabled && !posting}
                processing={posting}
                onClick={handleCreateOrUpdatePost}
                type="submit"
                // Client Rev 2, composer 7: "Change the primary CTA from Go
                // Public to: Post to League." Editing keeps "Update Post"
                // either way — that is the same action in both places.
                label={
                  postId
                    ? t("Update Post")
                    : game_id
                    ? "Post to League"
                    : t("go_public")
                }
                processingLabel={postId ? t("updating") : t("creating")}
                className="w-full  text-center mt-4 bg-teal-800 border-teal-800 hover:bg-teal-900 hover:border-teal-900 text-white font-poppins text-sm rounded py-3"
                unavailableClassName="opacity-60"
              />
            </div>
            {/* Client Rev 3, desktop private league: "Remove 'Your call is on the
                record' from the closing line, and center 'Post lock after 3
                minutes.' This should be completed for mobile as well."
                Already centred; the change is the copy. Scoped to the LEAGUE
                composer by its own key rather than editing post_lock_notice —
                that string is also the closing line on the main QUSHi composer at
                /create-feed, which the client did not ask about. Flagged for a
                decision rather than changed silently. */}
            <p className="text-xs font-medium text-gray-500 text-center mt-3">
              {game_id ? t("post_lock_notice_league") : t("post_lock_notice")}
            </p>
            <div className={isMobileView ? "mb-12" : "mb-2"}></div>
          </div>
        </div>
        </div>
      </Shell>
      {isPreviewVideo && (
        <PreviewVideo src={attachments} onClick={handleCloseVideoClick} />
      )}
    </>
  );
};

export default CreatePostPage;
